import { createActionGroup, props } from '@ngrx/store';

export const PoiIntSelectPaymentTypeComponentActions = createActionGroup({
  source: 'POI Int Select Payment Type Component',
  events: {
    'Selected Stripe Payment Type': props<{
      paymentDate: Date;
    }>(),
  },
});
